module.exports = __webpack_public_path__ + "static/img/hire.767d355.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/hire.png
// module id = SnPu
// module chunks = 0